import React from "react";
import { AVAILABLE_TOOLS } from "../../constants/agentTools";
import { toolsForAgentType } from "../../../../constants/agentChips";

interface ToolsSelectionSectionProps {
  selectedTools: string[];
  disabled?: boolean;
  onToolToggle: (toolId: string) => void;
  /** Offers only this type's tools (agentChips.ts) — omit while the agent's type hasn't loaded yet to show the full list. */
  agentType?: string;
}

const ToolsSelectionSection: React.FC<ToolsSelectionSectionProps> = ({
  selectedTools,
  disabled = false,
  onToolToggle,
  agentType,
}) => {
  const offeredTools = agentType
    ? AVAILABLE_TOOLS.filter((tool) => toolsForAgentType(agentType).includes(tool.id))
    : AVAILABLE_TOOLS;
  return (
    <div className="mb-6">
      <label className="block text-gray-700 font-medium mb-2">
        Tools (Optional)
      </label>
      <p className="text-sm text-gray-600 mb-3">
        Select tools to enable for this agent. Tools extend the agent's
        capabilities.
      </p>
      <div className="space-y-2 border border-gray-200 rounded-lg p-4 bg-gray-50">
        {offeredTools.map(
          (tool: { id: string; name: string; description: string }) => (
            <div
              key={tool.id}
              className="flex items-start space-x-3 p-2 hover:bg-surface-ui-hover rounded cursor-pointer"
              onClick={(e) => {
                // Don't trigger if clicking directly on the checkbox (it handles its own onChange)
                if ((e.target as HTMLElement).tagName !== "INPUT") {
                  !disabled && onToolToggle(tool.id);
                }
              }}
            >
              <input
                type="checkbox"
                id={`tool-${tool.id}`}
                checked={selectedTools.includes(tool.id)}
                onChange={() => onToolToggle(tool.id)}
                onClick={(e) => e.stopPropagation()}
                disabled={disabled}
                className="mt-1 h-4 w-4 text-brand-primary focus:ring-brand-primary border-gray-300 rounded cursor-pointer"
              />
              <div className="flex-1">
                <label
                  htmlFor={`tool-${tool.id}`}
                  className="text-sm font-medium text-gray-700 cursor-pointer"
                >
                  {tool.name}
                </label>
                {tool.description && (
                  <p className="text-xs text-gray-500 mt-0.5">
                    {tool.description}
                  </p>
                )}
              </div>
            </div>
          )
        )}
        {selectedTools.length === 0 && (
          <p className="text-sm text-gray-500 italic">
            No tools selected. Select tools above to enable them for this agent.
          </p>
        )}
      </div>
    </div>
  );
};

export default ToolsSelectionSection;
